module.exports = __webpack_public_path__ + "img/DAB-Profile-Prabhu-Antony.9cc5e2a0.png";